import { Injectable } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';

import { EasFieldType, EasFormService } from '@fry/components/common/easform';
import { EasBuilderField, EasBuilderGroup, TransitionAction } from '@fry/components/common/form-builder/builder.interfaces';
import { BuilderFormService } from '@fry/components/common/form-builder/form.service';
import {
  UserBookingsStore,
} from '@fry/booking/lib/bookings';
import { FillInFieldsComponent } from './fill-in-fields.component';

@Injectable()
export class FillInFieldsAction implements TransitionAction {
  actionId = 'fill_in_fields';
  scope = 'booking';

  constructor(
    private bookings: UserBookingsStore,
    private formService: BuilderFormService,
    private easForm: EasFormService,
  ) {}

  getComponent(doc: any, actionData: any) {
    return this.getForm(doc, actionData).pipe(
      map(form => {
        return {
          component: FillInFieldsComponent,
          data: {
            actionId: this.actionId,
            doc,
            actionData,
            group: this.easForm.createForm(form.form, form.initial)
          }
        }
      })
    );
  }

  getForm(doc: any, actionData: any) {
    const requiredFields: {id: string}[] = actionData.fields;

    actionData = actionData || {};
    // const initial = doc.metadata && doc.metadata.change_option && doc.metadata.change_option.option || '';
    const initial: any = {};

    return this.bookings.getWithDependencies(doc._id).pipe(
      switchMap(booking  => {
        const allFields = booking.bookingOption.form.group.fields;
        const fields: EasBuilderField[] = [];
        requiredFields.forEach(element => {
          const fld = allFields.find(fld => fld.id === element.id);
          if (fld) {
            fields.push(fld)
            let value = booking.doc.data[fld.id];
            if (fld.fieldType === 'userField' && (value === undefined || value === null)) {
              value = booking.owner.doc[fld.options.related];
            }

            initial[fld.id] = value;
          }
        });

        const form: EasBuilderGroup = {
          id: 'fill_in_fields',
          type: EasFieldType.Group,
          fieldType: 'asdf',
          fields: fields,
        }
        console.log(form);
        return this.formService.buildForm(form, { user: doc.user });
      }),
      map(form => {
        return {
          form: form,
          initial: initial
        }
      })
    );
  }


}
